/* eslint-disable react/no-unescaped-entities */
import React, { useContext } from 'react'
import { Box, Typography } from '@mui/material'

import { ScreenContext } from 'apps/utils/ScreenContext'
import { usePageTitle } from 'apps/utils/usePageTitle'
import SectionShell from 'apps/common/SectionShell'
import theme from 'theme'

import { useStyles } from './styles'

const AIPage = () => {
	usePageTitle( 'AI — ACT Software' )
	const classes = useStyles()
	const { isLaptop } = useContext( ScreenContext )

	return (
		<SectionShell railLabel='Artificial?'>
			<Box
				paddingRight={ theme.spacing( 6 ) }
				display='flex'
				alignItems='flex-start'
				justifyContent='flex-end'
				flexWrap='wrap'
				sx={{ gap: isLaptop ? '48px' : '24px' }}
			>
				<Box textAlign='right'>
					<Typography variant='h1' fontSize={ isLaptop ? '88px' : '60px' } lineHeight={ 1.05 }>
						Inspired by
					</Typography>
					<Typography
						variant='h1'
						fontSize={ isLaptop ? '88px' : '60px' }
						lineHeight={ 1.05 }
						color='var(--line)'
						sx={{ textDecoration: 'line-through' }}
					>
						Tired of
					</Typography>
				</Box>
				<Box
					className={ classes.pentagon }
					width={ isLaptop ? '320px' : '220px' }
					height={ isLaptop ? '304px' : '208px' }
					bgcolor='var(--ink)'
					display='flex'
					alignItems='center'
					justifyContent='center'
					flexShrink={ 0 }
				>
					{ /* The pentagon's visual centroid sits ~5.5% below its
					     geometric center (point-up shape), so a flex-centered
					     label reads as sitting above center — nudge it down. */ }
					<Typography
						variant='h2'
						color='var(--bg)'
						fontSize={ isLaptop ? '176px' : '120px' }
						marginTop={ isLaptop ? '34px' : '23px' }
					>
						AI
					</Typography>
				</Box>
			</Box>
			<Box
				maxWidth={ isLaptop ? '760px' : '100%' }
				marginTop={ isLaptop ? '80px' : '40px' }
				marginBottom={ isLaptop ? '64px' : '32px' }
				paddingLeft={ theme.spacing( 6 ) }
				paddingRight={ theme.spacing( 6 ) }
				sx={{
					fontSize: isLaptop ? '17px' : '15px',
					lineHeight: 1.7,
					color: 'var(--ink)'
				}}
			>
				<Box component='p' marginBottom='20px'>
					Although it's not necessarily an "intelligence", it is certainly an artificial
					instrument to speed up a lot of routines. Like most software teams, we use
					agentic AI intensively. But the fact of usage doesn't make one outstanding,
					similar to using a programming language and a compiler.
				</Box>
				<Box component='p' marginBottom='12px'>
					Then the choice occurs:
				</Box>
				<Box component='ul' margin='0 0 20px' paddingLeft='22px'>
					<Box component='li' marginBottom='8px'>
						Continue delivering same volumes and lay off part of engineering, or
					</Box>
					<Box component='li'>
						Keep all engineers and start demanding more delivery volumes
					</Box>
				</Box>
				<Box component='p' marginBottom='20px'>
					Most software companies choose the latter, because for a fraction of the cost it
					is now possible to plug in a third hemisphere into an engineer's brain.
				</Box>
				<Box component='p' marginBottom='20px'>
					Imagine a logistics company equipped their drivers with x1.5 faster trucks
					which are 85% reliable. HR and insurance are OK with that, because financial
					people made them shut up with new numbers. Now drivers have to keep extra
					focus, because of higher velocity, projecting constant stress onto their
					nervous system from start to stop. No more relaxed takeaway-coffee drinking
					behind the wheel, and eventually men can hardly tell whether there is Mark
					Knopfler on the radio or Chuck Berry. Distraction is no longer an option. You
					should now cover more mileage per day with your lunchbox of the same size.
				</Box>
				<Box component='p' marginBottom='20px'>
					More specs, designs, plans, lines of code reviewed daily, more chats in
					parallel. Many of them now with a synthetic colleague who introduced a "You're
					absolutely right"-style of redundant texting. More reading, more typing,
					hopefully with accuracy lost not too often.
				</Box>
				<Box component='p' marginBottom='20px'>
					Thus, the planet's IT community, who contributed for years to the various
					software which helped big tech to build their frontier LLMs, instead of
					becoming the first beneficiary of brilliant new tools, have become its first
					victim. Ironically, isn't it?
				</Box>
				<Typography variant='h3' textAlign='right' sx={{ marginTop: '40px' }}>
					So, who's whose resource?
				</Typography>
			</Box>
		</SectionShell>
	)
}

export default AIPage
